<zui-process-notification-shell
  [isSystem]="actionsMap[data?.actionName]?.isSystem || data?.createdByUser.type === 'SYSTEM'"
  [fullName]="data?.createdByUser?.fullName"
  [email]="data?.createdByUser?.email"
  [image]="data?.createdByUser?.avatar?.smallAvatarUrl"
  [created]="data?.created"
  [createdByType]="data?.createdByUser?.type"
  [firstName]="data?.createdByUser?.firstName"
  [externalImage]="data?.createdByUser?.avatar?.externalAvatarUrl"
  [prefixText]="'Created by'"
  [color]="statusColorClassMap[data?.status]">

  <ng-container *zefMessageFormat="let mf">

    <!-- build & deploy pipeline steps -->
    @if (data?.appVersion) {

      @if (makeContentScrollable) {
        <zef-scrollbar maxHeight="205px">
          <div class="fx:pb-1">
            <ng-template [ngTemplateOutlet]="appVersion" />
          </div>
        </zef-scrollbar>
        <ng-template [ngTemplateOutlet]="pipelineDetailButton" />
      } @else {
        <ng-template [ngTemplateOutlet]="appVersion" />
      }

    }

    <!-- other -->
    <div  *ngIf="!data?.appVersion">

      <zui-process-notification-desc (linkClicked)="internalLinkClicked.emit()">

        <span
          *ngIf="data?.status === processStatuses.RUNNING"
          [innerHTML]="(translations && translations.running[(data?.actionName | normalizeActionName)]
            ? mf(translations.running[(data?.actionName | normalizeActionName)], {
                serviceType: data?.serviceStacks[0]?.serviceStackTypeInfo?.serviceStackTypeName,
                serviceName: data?.serviceStacks[0]?.name,
                serviceId: data?.serviceStacks[0]?.id,
                projectId: data?.projectId,
                projectName: data?.project.name
              })
            : data?.actionName
          ) | safeHtml">
        </span>

        <span
          *ngIf="data?.status === processStatuses.PENDING"
          [innerHTML]="(translations && translations.pending[(data?.actionName | normalizeActionName)]
            ? mf(translations.pending[(data?.actionName | normalizeActionName)], {
              serviceType: data?.serviceStacks[0]?.serviceStackTypeInfo?.serviceStackTypeName,
              serviceName: data?.serviceStacks[0]?.name,
              serviceId: data?.serviceStacks[0]?.id,
              projectId: data?.projectId,
              projectName: data?.project.name
            })
            : data?.actionName
          ) | safeHtml">
        </span>

      </zui-process-notification-desc>

      <div class="__process-footer">

        <div class="__process-time">
          <zui-process-notification-duration
            [type]="data?.status === processStatuses.PENDING ? 'QUEUED' : 'TIMER'"
            [start]="data?.started">
          </zui-process-notification-duration>
        </div>

        @if (!hideCancel && !isReadOnly()) {
          <div class="__process-cancel-wrap" *ngIf="data?.status === processStatuses.PENDING">
            <ng-template [ngTemplateOutlet]="cancelButton"></ng-template>
          </div>
        }

      </div>
    </div>

  </ng-container>

</zui-process-notification-shell>

<ng-template #cancelButton>
  <button
    (click)="cancelClicked.emit(data?.id)"
    class="__cancel-button  c-button c-button--smaller"
    type="button"
    mat-button>
    Cancel process
  </button>
</ng-template>

<ng-template #pipelineDetailButton>
  <div
    class="__button-wrap"
    [class.is-scrollable]="makeContentScrollable">
    <button
      (click)="pipelineDetailClicked.emit({ appVersion: data?.appVersion, pipelineErrors: pipelineErrors ?? [] })"
      mat-flat-button
      class="[ c-button  c-button--smaller ]  __pipeline-button"
      type="button">
      Open pipeline detail <mat-icon>aspect_ratio</mat-icon>
    </button>
  </div>
</ng-template>

<ng-template #appVersion>

  <zui-pipeline-desc
    class="__build-desc"
    [serviceName]="data?.serviceStacks[0].name"
    [serviceType]="data?.serviceStacks[0].serviceStackTypeInfo?.serviceStackTypeName"
    [serviceTypeId]="data?.serviceStacks[0]?.serviceStackTypeId"
    [projectName]="data?.project.name"
    [serviceId]="data?.serviceStacks[0].id"
    [projectId]="data?.projectId"
    [appVersion]="data?.appVersion"
    [actionName]="data?.actionName"
    (linkClicked)="internalLinkClicked.emit()">
  </zui-pipeline-desc>

  <div class="__process-time">

    <zui-process-notification-duration
      class="__duration"
      [type]="data?.status === processStatuses.PENDING ? 'QUEUED' : 'TIMER'"
      [start]="data?.started">
    </zui-process-notification-duration>

    @if (data?.status === processStatuses.RUNNING && isBuildInProgress && !isReadOnly()) {
      <button
        type="button"
        mat-flat-button
        class="[ c-button  c-button--smaller ]  __cancel-button  __cancel-build-button"
        (click)="buildCancelClicked.emit(data.appVersion?.id)"
        [disabled]="!!data.cancelRequested">

        @if (!data.cancelRequest && !data.cancelRequested) {
          <mat-icon fontSet="material-icons-outlined" class="__cancel-build-button_icon">cancel</mat-icon>&nbsp;<span class="__cancel-build-button_text">Cancel Build</span>
        }

        @if (!!data.cancelRequested) {
          <div class="__cancel-build-button_cancel-request">
            Canceling <zui-three-dots />
          </div>
        }
      </button>
    }

    @if (!hideCancel && data?.status === processStatuses.PENDING && !isReadOnly()) {
      <div class="__process-cancel-wrap">
        <ng-template [ngTemplateOutlet]="cancelButton"></ng-template>
      </div>
    }

  </div>

  @if (data?.status === processStatuses.RUNNING && data.actionName !== 'stack.deploy.backup') {

    <zui-separator
      class="__separator"
      [position]="'start'"
      [size]="'mini'"
      [spacing]="'mini'">
    </zui-separator>

    <zui-build-state-steps
      class="__build-steps"
      [serviceName]="data?.serviceStacks[0]?.name"
      [serviceType]="data?.serviceStacks[0]?.serviceStackTypeInfo?.serviceStackTypeName"
      [projectId]="data?.projectId"
      [appVersion]="data?.appVersion"
      [pipelineErrors]="pipelineErrors">
    </zui-build-state-steps>

    @if (data?.appVersion?.source !== 'GUI' && (!!data?.appVersion?.build || !!data?.appVersion?.prepareCustomRuntime) && !makeContentScrollable) {

      <zui-separator
        class="__separator"
        [position]="'start'"
        [size]="'mini'"
        [spacing]="'mini'">
      </zui-separator>

      <ng-template [ngTemplateOutlet]="pipelineDetailButton"></ng-template>

    }

  }

</ng-template>
